import { Component, OnInit, OnDestroy } from '@angular/core';

import { Router } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { CardComponent } from './card/card.component';
import { RoleService } from 'src/app/core/services/role.service';
import { Role } from '@models/enums';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-home',
    imports: [MatDividerModule, ArianeNavComponent, MatIconModule, MatButtonModule, CardComponent],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  arianeLabel: string = 'Gestion des demandes';
  arianeIcon: string = 'format_align_left';
  public homeCards = [
    {
      icon: 'Contract',
      title: 'Formulaire recrutement',
      body: 'Accéder au formulaire saisies demandes de recrutement.',
      link: 'DEMANDE DE RECRUTEMENT',
      routerLink: 'pama/recrutement',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR],
      show: false
    },
    {
      icon: 'Contract_edit',
      title: 'Formulaire renouvellement',
      body: 'Accéder au formulaire saisies demandes de renouvellement.',
      link: 'RENOUVELEMENT',
      routerLink: 'pama/renouvellement',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR],
      show: false
    },
    {
      icon: 'quick_reference_all',
      title: 'Consultation des demandes',
      body: 'Accéder au listing des demandes.',
      link: 'CONSULTATION DES DEMANDES',
      routerLink: 'pama/consultation',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR],
      show: false
    },
    {
      icon: 'task_alt',
      title: 'Validation des demandes',
      body: 'Accéder au listing des demandes à valider.',
      link: 'VALIDATION DES DEMANDES',
      routerLink: 'pama/validation-demandes',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR],
      show: false
    },
    {
      icon: 'quick_reference_all',
      title: 'Consultation fin de contrats',
      body: 'Accéder au listing fin de contrats.',
      link: 'CONSULTATION FIN DE CONTRATS',
      routerLink: 'pama/consultation-fin-contrats',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER],
      show: false
    },
    {
      icon: 'quick_reference_all',
      title: 'Consultation annuaire des postes',
      body: 'Accéder au listing des postes.',
      link: 'CONSULTATION ANNUAIRE DES POSTES',
      routerLink: 'pama/consultation-annuaire-poste',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_USER, Role.PAMA_VALIDATEUR],
      show: false
    },
    {
      icon: 'star_border',
      title: "Demandes d'avis",
      body: "Accéder au listing des demandes d'avis à répondre.",
      link: "DEMANDES D'AVIS",
      routerLink: 'pama/demande-avis-list',
      requiredRoles: [Role.PAMA_ADMIN, Role.PAMA_VALIDATEUR, Role.PAMA_USER],
      show: false
    },
    {
      icon: 'settings',
      title: 'Administration',
      body: "Donne accès au fonctions d'administration.",
      link: 'ADMINISTRATION',
      routerLink: 'pama/administration',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    }
  ];
  chartActif: boolean | null = null;

  userRoles: Role[] = [];
  totalDemandeAvis: number = 0;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly redirection: Broadcast,
    private readonly router: Router,
    private readonly roleService: RoleService,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.roleService
      .getRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe((roles) => {
        this.userRoles = roles as Role[];
        this.accessToCard();
      });

    this.notificationService.validationCounts$.pipe(takeUntil(this.destroy$)).subscribe((counts) => {
      this.totalDemandeAvis = counts?.totalDemandeAvis ?? 0;
      this.accessToCard();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  redirection_accueil(chartActif?: boolean) {
    let _url = this.router.url.split('?');
    let url = _url[0].replace('/', '');

    if (url == 'accueil') {
      this.chartActif = !this.chartActif;
    } else {
      this.chartActif = true;
    }

    this.router.navigate(['/', 'accueil'], { queryParams: { chartActif: this.chartActif } });
  }
  navigateToCard(section: any) {
    this.router.navigateByUrl(section.routerLink);

    this.redirection.broadcastEvent(section.link);
  }
  accessToCard() {
    this.homeCards.forEach((card) => {
      card.show = this.roleService.canAccess(card.requiredRoles);
    });
  }
}
